import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./store";
import { ServiceLocater, Services } from "../service-locater";
import {
  UserRepository,
  Loading,
  PasswordValidationStatus,
  validatePassword,
  validateEmail,
  UserFailure,
} from "../domain";

type RegisterFormState = {
  firstName: string;
  surName: string;
  password: string;
  repeatPassword: string;
  passwordValidationStatus: PasswordValidationStatus | "invalid";
  email?: string;
  isEmailValid?: boolean;
  hasSubmitted: boolean;
  loading: Loading;
  failure?: UserFailure;
};

const initialState: RegisterFormState = {
  firstName: "",
  surName: "",
  password: "",
  repeatPassword: "",
  passwordValidationStatus: "invalid",
  hasSubmitted: false,
  loading: "idle",
};

const registerFormSlice = createSlice({
  name: "registerForm",
  initialState,
  reducers: {
    setFirstName(state, action) {
      state.failure = undefined;
      state.firstName = action.payload;
    },
    setSurName(state, action) {
      state.failure = undefined;
      state.surName = action.payload;
    },
    setPassword(state, { payload }) {
      state.failure = undefined;
      state.passwordValidationStatus = validatePassword(
        payload,
        state.repeatPassword
      );
      state.password = payload;
    },
    setRepeatPassword(state, { payload }) {
      state.failure = undefined;
      state.passwordValidationStatus = validatePassword(
        state.password,
        payload
      );
      state.repeatPassword = payload;
    },
    setEmail(state, { payload }) {
      state.failure = undefined;
      if (payload !== "") state.isEmailValid = validateEmail(payload);
      state.email = payload;
    },
    registerFormSubmitted(state) {
      state.hasSubmitted = true;
    },
    regirsterFormLoading(state) {
      state.failure = undefined;
      state.loading = "pending";
    },
    regirsterFormSuccess(state) {
      state.failure = undefined;
      state.loading = "succeeded";
    },
    regirsterFormFailure(state, { payload }) {
      state.failure = payload;
      state.loading = "failed";
    },
  },
});

export const {
  setFirstName,
  setSurName,
  setPassword,
  setRepeatPassword,
  setEmail,
  registerFormSubmitted,
} = registerFormSlice.actions;
export default registerFormSlice.reducer;

const {
  regirsterFormLoading,
  regirsterFormSuccess,
  regirsterFormFailure,
} = registerFormSlice.actions;

export const register = (phone: string): AppThunk => async (
  dispatch,
  getState
) => {
  dispatch(registerFormSubmitted());
  const {
    passwordValidationStatus,
    isEmailValid,
    email,
  } = getState().registerForm;
  if (
    passwordValidationStatus === "valid" &&
    (isEmailValid || email === "" || email === undefined)
  ) {
    dispatch(regirsterFormLoading());
    const { firstName, surName, password, email } = getState().registerForm;
    const res = await ServiceLocater.get<UserRepository>(
      Services.UserRepository
    ).register(firstName, surName, phone, password, email);
    res.fold(
      (l) => dispatch(regirsterFormFailure(l)),
      (r) => dispatch(regirsterFormSuccess())
    );
  }
};
